export const cars = [
  {
    brand: "Mercedes-Benz",
    model: "GLK-Class",
    type: "SUV", // Tipo: SUV
    image: "https://freepngimg.com/thumb/car/10-2-car-download-png.png",
    dailyPrice: 100,
    doors: 4,
    hasAirConditioning: true,
    fuelType: "Gasolina",
    year: 2011,
    transmissionType: "Automática"
  },
  {
    brand: "Fiat",
    model: "Toro",
    type: "Pickup", // Tipo: Pickup
    image:
      "https://freepngimg.com/thumb/car/81496-fiat-car-toro-automobiles-motor-vehicle.png",
    dailyPrice: 80,
    doors: 4,
    hasAirConditioning: false,
    fuelType: "Flex",
    year: 2019,
    transmissionType: "Manual"
  },
  {
    brand: "Honda",
    model: "Civic",
    type: "Sedan", // Tipo: Sedan
    image: "https://pngimg.com/uploads/honda/honda_PNG10358.png",
    dailyPrice: 90,
    doors: 4,
    hasAirConditioning: true,
    fuelType: "Gasolina",
    year: 2020,
    transmissionType: "Automática"
  },
  {
    brand: "Mitsubishi",
    model: "Lancer",
    type: "Sedan", // Tipo: Sedan
    image: "https://pngimg.com/uploads/mitsubishi/mitsubishi_PNG189.png",
    dailyPrice: 85,
    doors: 4,
    hasAirConditioning: true,
    fuelType: "Gasolina",
    year: 2018,
    transmissionType: "Automática"
  },
  {
    brand: "Volkswagen",
    model: "Gol",
    type: "Hatchback", // Tipo: Hatchback
    image: "https://pngimg.com/uploads/volkswagen/volkswagen_PNG1821.png",
    dailyPrice: 75,
    doors: 4,
    hasAirConditioning: false,
    fuelType: "Flex",
    year: 2022,
    transmissionType: "Manual"
  },
  {
    brand: "Volkswagen",
    model: "Polo Compact Sedan",
    type: "Sedan", // Tipo: Sedan
    image: "https://pngimg.com/uploads/volkswagen/volkswagen_PNG1815.png",
    dailyPrice: 85,
    doors: 4,
    hasAirConditioning: true,
    fuelType: "Flex",
    year: 2021,
    transmissionType: "Automática"
  }
];
